import { motion } from "framer-motion";
import { Activity, ShieldCheck, Stethoscope, HeartPulse, Building2, Hospital } from "lucide-react";

const PROVIDERS = [
  { name: "Apex Medical", icon: Activity },
  { name: "Horizon Health", icon: ShieldCheck },
  { name: "Meridian Diagnostics", icon: Stethoscope },
  { name: "Northstar Imaging", icon: HeartPulse },
  { name: "Vanta Clinical", icon: Building2 },
  { name: "Lumen Hospitals", icon: Hospital },
];

export default function TrustStrip() {
  const items = [...PROVIDERS, ...PROVIDERS]; // duplicate for seamless marquee

  return (
    <section
      data-testid="trust-strip"
      className="relative bg-[#071B34] border-t border-white/5"
    >
      {/* Subtle gradient fade to light section below */}
      <div className="absolute bottom-0 inset-x-0 h-24 bg-gradient-to-b from-transparent to-[#F9FBFD] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col items-center text-center mb-10"
        >
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[#14D6C7]/80 font-manrope font-semibold">
            <span className="block w-8 h-px bg-[#14D6C7]/40" />
            Trusted Network
            <span className="block w-8 h-px bg-[#14D6C7]/40" />
          </div>
          <p className="mt-4 text-white/55 font-poppins text-sm sm:text-base">
            Trusted by forward-thinking healthcare providers.
          </p>
        </motion.div>

        <div className="marquee">
          <div className="marquee-track">
            {items.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={`${p.name}-${i}`}
                  className="flex items-center gap-3 text-white/45 hover:text-white/80 transition-colors duration-300 whitespace-nowrap"
                >
                  <Icon className="w-5 h-5 text-[#14D6C7]/70" strokeWidth={1.5} />
                  <span className="text-base sm:text-lg font-manrope font-medium tracking-tight">
                    {p.name}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
